import PageHeader from "../../../../core/common/crmComponents/PageHeader";
import CardHeader from "../components/CardHeader";
import AddUser from "../actions/AddUser";
import UserList from "../components/UserList";
import PaginationControls from "../../../../core/common/pagination";
import { useUsersData } from "../hooks/useUsersData";
import { useEffect, useState } from "react";
import { MODULES } from "../../../../core/data/constants/moduleConstants";
import { useDebounce } from "use-debounce";
import LoaderComponent from "../../../../core/common/crmComponents/LoaderComponent";
import { useLocation, useNavigate } from "react-router";
import { Link, useSearchParams } from "react-router-dom";
import { all_routes } from "../../../router/all_routes";
import { IoIosArrowRoundBack } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import {
  getUrlParams,
  setUrlParams,
} from "../../../../utils/helpers/setAndGetUrlParams";
import { generateQueryParams } from "../../../../utils/helpers/generateQueryParams";
import queryClient from "../../../../config/queryClient";
import { setReloading } from "../../../../core/data/redux/moduleDataSlice";

const Manageusers = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const user = JSON.parse(localStorage.getItem("user") || []);
  const roleNameArr = JSON.parse(localStorage.getItem("roleNameArr"));
  const { companyNameArr } = useSelector((state) => state.auth);
  const reloading = useSelector((state) => state.moduleData.reloading);

  const initialLimit = getUrlParams("limit")
    ? Math.ceil(getUrlParams("limit"))
    : 50;
  const initialPage = getUrlParams("page") ? Number(getUrlParams("page")) : 1;
  const initialCompany = getUrlParams("companyid")
    ? getUrlParams("companyid")
    : user?.ofCompany?._id ||
      (companyNameArr.length > 0 ? companyNameArr[0].value : null);

  const [limit, setLimit] = useState(initialLimit);
  const [page, setPage] = useState(initialPage);
  const [selectedCompany, setSelectedCompany] = useState(initialCompany);

  const { filters } = useSelector((state) => state.filter);
  const usersFilters = filters.users || [];

  const { queryParams, params } = generateQueryParams(usersFilters);

  const { data, isLoading, isError, error, isFetching } = useUsersData({
    page: page ? page : 1,
    limit: limit ? limit : 50,
    ofCompany: selectedCompany ? selectedCompany : null,
    queryString: params.toString(),
    queryParams: queryParams.toString(),
  });

  const usersData = data?.data?.data;

  const totalCount = data?.data?.totalResult;
  const totalPages = Math.ceil(totalCount / limit);

  useEffect(() => {
    if (!searchParams.get("companyid")) {
      setUrlParams(setSearchParams, "companyid", initialCompany);
    }
    setSelectedCompany(initialCompany);
  }, [initialCompany]);

  useEffect(() => {
    if (totalPages > 0 && page > totalPages) {
      setPage(totalPages); // Reset to the last available page
      setUrlParams(setSearchParams, "page", totalPages);
    }
  }, [totalPages, page, setSearchParams]);

  useEffect(() => {
    if (searchParams.get("page") !== String(page)) {
      setUrlParams(setSearchParams, "page", page);
    }
  }, [page]);

  useEffect(() => {
    if (selectedCompany) {
      setUrlParams(setSearchParams, "companyid", selectedCompany);
    }
  }, [selectedCompany]);

  useEffect(() => {
    if (
      searchParams.get("page") &&
      searchParams.get("limit") !== String(limit)
    ) {
      setUrlParams(setSearchParams, "limit", limit);
    }
  }, [limit]);

  const handlePageChange = (newPage) => {
    setPage(newPage); // Update page state to trigger refetch
  };

  const handleLimitChange = (newLimit) => {
    setLimit(newLimit);
    setPage(1); // Reset page to 1 whenever limit changes
  };

  useEffect(() => {
    if (usersFilters?.length > 0) {
      setPage(1);
    }
  }, [usersFilters]);

  useEffect(() => {
    if (reloading) {
      queryClient.invalidateQueries(["users"]);
      dispatch(setReloading(false));
    }
  }, [reloading, dispatch]);

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content custom-content-padding">
          <div className="row">
            <div className="col-md-12">
              {/* Page Header */}
              <PageHeader pageName="Users" totalCount={totalCount}>
                <button
                  className="p-2 btn btn-outline-none"
                  onClick={() => navigate(all_routes.settings)}
                >
                  <IoIosArrowRoundBack className="d-inline" size={20} />
                </button>
              </PageHeader>

              <div className="card">
                <CardHeader
                  selectedCompany={selectedCompany}
                  setSelectedCompany={setSelectedCompany}
                  user={user}
                />
                <div className="card-body py-2">
                  <PaginationControls
                    totalCount={totalCount}
                    totalPages={totalPages}
                    currentPageDataCount={Math.min(usersData?.length, limit)}
                    onPageChange={handlePageChange}
                    onLimitChange={handleLimitChange}
                    moduleName={MODULES.USERS}
                  />
                  {/* <Filter /> */}
                  {isLoading ? (
                    <LoaderComponent />
                  ) : (
                    <UserList usersData={usersData} />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}
      <AddUser roleNameArr={roleNameArr} companyNameArr={companyNameArr} />
      {/* <DeleteUser /> */}
    </>
  );
};

export default Manageusers;
